import type { Dispatch } from 'redux';
import { ensureCsrfCookie, getUser, type LoginUser } from '@/services/auth';
import { clearAuthMarkerCookie, hasAuthMarkerCookie, redirectToLogin } from '@/utils/authSession';
import { applyAppLanguage } from '@/store/useLanguageStore';
import { isAppLanguage } from '@/i18n';

export default async function checkLogin(dispatch: Dispatch): Promise<LoginUser | null> {
  dispatch({ type: 'set-hydrated', payload: false });

  if (!hasAuthMarkerCookie()) {
    dispatch({ type: 'update-user', payload: { user: null } });
    dispatch({ type: 'set-hydrated', payload: true });
    return null;
  }

  dispatch({ type: 'update-user', payload: { user: null, userLoading: true } });

  try {
    await ensureCsrfCookie();
    const user = await getUser();

    // 登录后以后端语言偏好为准，覆盖本地存储
    if (isAppLanguage(user?.language)) {
      applyAppLanguage(user.language);
    }

    dispatch({ type: 'update-user', payload: { user, userLoading: false } });
    dispatch({ type: 'set-hydrated', payload: true });
    return user;
  } catch {
    clearAuthMarkerCookie();
    dispatch({ type: 'update-user', payload: { user: null } });
    dispatch({ type: 'set-hydrated', payload: true });
    redirectToLogin();
    return null;
  }
}
